import { Container, Stack, Typography } from "@mui/material";
import {
  useGetMapInsurersQuery,
  useGetOriginationTabQuery,
} from "api/api-maps";
import MainCard from "components/Common/Cards/MainCard";
import { MapContext } from "pages/maps/map";
import React from "react";

const OriginOfTheDeal: React.FC = () => {
  const mapName = React.useContext(MapContext);
  const { data: mapInsurers } = useGetMapInsurersQuery(mapName ?? "", {
    skip: mapName === undefined,
  });
  const { data: tabData } = useGetOriginationTabQuery(mapName ?? "", {
    skip: mapName === undefined,
  });

  return (
    <Container>
      <Stack justifyContent="center" alignItems="center" pt={2} spacing={2}>
        <Typography variant="h2" textAlign="center">
          Origin of the Deal
        </Typography>
        <MainCard
          content
          boxShadow
          contentSX={{
            bgcolor: "#a2a6c338",
            px: 0.5,
            py: 0.25,
            ":last-child": {
              p: 1,
            },
          }}
        >
          <Stack spacing={2}>
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography fontWeight={600} minWidth={180}>
                Origin of the Deal:
              </Typography>
              <Typography>
                {mapInsurers?.buyer?.source || "Not Specified"}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography fontWeight={600} minWidth={180}>
                Responsible Sales Manager:
              </Typography>
              <Typography>
                {mapInsurers?.sales_lead?.first_name
                  ? `${mapInsurers?.sales_lead?.first_name} ${mapInsurers?.sales_lead?.last_name}`
                  : "Not Specified"}
              </Typography>
            </Stack>
            {/* Render all other tabData fields except the above two, if needed */}
            {/* Example: Deal Origin Details (if present in tabData) */}
            {tabData?.deal_origin && (
              <Stack>
                <Typography fontWeight={600} minWidth={180}>
                  Additional Deal Origin Details:
                </Typography>
                <Stack
                  dangerouslySetInnerHTML={{
                    __html: tabData.deal_origin,
                  }}
                  margin="auto"
                  sx={{
                    ".ql-align-justify": {
                      margin: 0,
                      marginBottom: 0.25,
                      fontSize: "0.5rem",
                    },
                  }}
                />
              </Stack>
            )}
            {/* Add more tabData fields here as needed, except for the two above */}
          </Stack>
        </MainCard>
      </Stack>
    </Container>
  );
};

export default OriginOfTheDeal;
